import { BonificoOrderDTO } from "../../ProductService/BonificoOrder/BonificoOrderDTO.ts";
import { formatBusinessAddress } from "../../ProductService/BonificoOrder/bonificoBilling.ts";
import { businessTypeLabels } from "../../MoneyTransfer/BusinessType.tsx";
import { isForeignBillingCountry } from "../../MoneyTransfer/billingCountries.ts";

export function BonificoBillingSummary({
  order,
  onEdit,
}: {
  order: BonificoOrderDTO;
  onEdit?: () => void;
}) {
  const billing = order.businessInformation;
  if (!billing) return null;
  const holder =
    billing.businessName ||
    `${order.customer.firstName} ${order.customer.lastName}`;
  const details = [
    businessTypeLabels[billing.businessType] ?? billing.businessType,
    billing.vatCode &&
      (isForeignBillingCountry(billing.businessAddress.country)
        ? `Tax ID ${billing.vatCode}`
        : `P.IVA ${billing.vatCode}`),
    order.customer.taxCode && `CF ${order.customer.taxCode}`,
    formatBusinessAddress(billing.businessAddress),
    billing.sdiCode && `SDI ${billing.sdiCode}`,
    billing.pec && `PEC ${billing.pec}`,
  ].filter((detail): detail is string => !!detail);

  return (
    <div className="rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-xs text-gray-700 flex flex-col gap-0.5">
      <div className="flex items-center justify-between gap-2">
        <span className="font-semibold uppercase tracking-wide text-gray-500">
          Dati di fatturazione
        </span>
        {onEdit && (
          <button
            type="button"
            onClick={onEdit}
            className="text-blue-600 hover:underline"
          >
            Modifica
          </button>
        )}
      </div>
      <span className="text-sm font-medium text-gray-900">{holder}</span>
      {details.map((detail) => (
        <span key={detail}>{detail}</span>
      ))}
    </div>
  );
}
